import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import TicketingSystem from 'ui/organizms/Merchants/TicketingSystem';

const TicketingSystemScreen = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Merchants | Ticketing System'
    >
        <TicketingSystem />
    </Screen>
);

export default memo(TicketingSystemScreen);
